(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ym-limited-badge"] && !Shopify.designMode) return;
  try {
    /* Countdown for every [data-ym-countdown] on the page, ticking once a second. Looking the
     elements up on every tick means badges added later (quick add, filters, cart drawer) work too.
     One day or more left: "2d 16h 5m". Under 24 hours: "03h 12m 45s".
     At zero the badge is removed. */
  (function () {
    if (window.__ymLimitedTimer) return;
    window.__ymLimitedTimer = true;

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function format(ms) {
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      if (d > 0) return d + 'd ' + h + 'h ' + m + 'm';
      return pad(h) + 'h ' + pad(m) + 'm ' + pad(s % 60) + 's';
    }

    function expire(el) {
      var badge = el.closest('[data-ym-limited]');
      if (badge) badge.remove();
    }

    function tick() {
      var now = Date.now();
      document.querySelectorAll('[data-ym-countdown]').forEach(function (el) {
        var end = Number(el.getAttribute('data-ym-countdown')) * 1000;
        if (!end) return;
        var left = end - now;
        if (left <= 0) {
          expire(el);
          return;
        }
        var val = el.querySelector('.ym-limited__val');
        if (val) val.textContent = format(left);
      });
    }

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
